import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import MainLayout from '../components/layout/MainLayout';
import { SectionHome, LAST_TAB_PREFIX } from '../components/enterprise';
import { FileSearch, Gauge, ArrowRight } from 'lucide-react';

const getLastTab = (section) => {
  try {
    const raw = localStorage.getItem(`${LAST_TAB_PREFIX}${section}`);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

const BeoordelenHomePage = () => {
  const { api } = useAuth();
  const [stats, setStats] = useState({ nulmetingPct: 0, maturityDone: 0, maturityTotal: 24 });
  const lastTab = getLastTab('beoordelen');

  useEffect(() => {
    const fetch = async () => {
      try {
        const [p, pr, t, m] = await Promise.all([
          api.get('/people/stats').catch(() => ({ data: {} })),
          api.get('/process/stats').catch(() => ({ data: {} })),
          api.get('/technology/stats').catch(() => ({ data: {} })),
          api.get('/maturity/indicators').catch(() => ({ data: [] })),
        ]);
        const pp = p.data || {}, ppr = pr.data || {}, tt = t.data || {};
        let peopleP = pp.hr_assessment_status === 'completed' ? 100 : Math.round(((pp.hr_assessment_answered || 0) / (pp.hr_assessment_total || 15)) * 100);
        let processP = (ppr.completed || 0) >= 2 ? 100 : (ppr.completed || 0) >= 1 ? 66 : (ppr.in_progress || 0) > 0 ? 33 : 0;
        let techP = (tt.total_targets || 0) > 0 && (tt.completed_scans || 0) > 0 ? 100 : (tt.total_targets || 0) > 0 ? 50 : 0;
        const nulmetingPct = Math.round((peopleP + processP + techP) / 3);
        const indicators = Array.isArray(m.data) ? m.data : [];
        const maturityDone = indicators.filter(i => i.level && i.level > 0).length;
        setStats({ nulmetingPct, maturityDone, maturityTotal: indicators.length || 24 });
      } catch {}
    };
    fetch();
  }, [api]);

  return (
    <MainLayout>
      <SectionHome
        question="Wat wil je onderzoeken?"
        subtitle="Kies het resultaat dat je vandaag wilt bereiken."
        resume={lastTab ? { title: lastTab.label, href: lastTab.href } : undefined}
        recommended={{
          title: 'Breng onze huidige beveiliging in kaart',
          description: 'Start of vervolg de nulmeting voor mensen, organisatie en systemen. Dit is de basis voor alle risico- en verbeteranalyses.',
          href: '/beoordelen/nulmeting',
          status: stats.nulmetingPct > 0 ? `${stats.nulmetingPct}% voltooid` : null,
          duration: stats.nulmetingPct > 0 ? 'Ga verder waar je gebleven bent' : 'Ongeveer 40 minuten',
          icon: FileSearch,
        }}
        alternatives={[
          {
            title: 'Beoordeel hoe volwassen onze beveiliging is',
            description: 'Beoordeel beleid en uitvoering via 24 indicatoren.',
            href: '/beoordelen/volwassenheid',
            status: `${stats.maturityDone}/${stats.maturityTotal} beoordeeld`,
            icon: Gauge,
          },
        ]}
        overviewHref="/beoordelen/nulmeting"
        overviewLabel="Bekijk de nulmeting direct"
        testId="beoordelen-home"
      />
    </MainLayout>
  );
};

export default BeoordelenHomePage;
